var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServe1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6 22.8H26.4V67.2H45.6V22.8Z",
    fill: "#5B21FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 10.8H2.39999V67.2001H21.6V10.8Z",
    fill: "#5B21FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6 31.2H50.4V67.2H69.6V31.2Z",
    fill: "#5B21FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2 33.4801C41.04 34.5601 41.04 36.1201 40.32 37.2001C38.76 39.6001 35.52 40.2001 33.12 38.6401C32.52 38.2801 32.04 37.8001 31.68 37.2001C30.96 36.0001 31.08 34.5601 31.8 33.4801L36 27.6001L40.2 33.4801Z",
    fill: "#EEE8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 21.4799C17.04 22.5599 17.04 24.1199 16.32 25.1999C14.76 27.5999 11.52 28.1999 9.12001 26.6399C8.52001 26.2799 8.04001 25.7999 7.68001 25.1999C6.96001 23.9999 7.08001 22.5599 7.80001 21.4799L12 15.5999L16.2 21.4799Z",
    fill: "#EEE8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67.2H0V72H72V67.2Z",
    fill: "#5B21FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6 44.3999H26.4V67.1999H45.6V44.3999Z",
    fill: "#EEE8FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 32.3999H2.39999V67.1999H21.6V32.3999Z",
    fill: "#EEE8FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 62.4001C34.9255 62.4001 36 61.3256 36 60.0001C36 58.6746 34.9255 57.6001 33.6 57.6001C32.2745 57.6001 31.2 58.6746 31.2 60.0001C31.2 61.3256 32.2745 62.4001 33.6 62.4001Z",
    fill: "#5B21FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4 54C39.7255 54 40.8 52.9254 40.8 51.6C40.8 50.2745 39.7255 49.2 38.4 49.2C37.0745 49.2 36 50.2745 36 51.6C36 52.9254 37.0745 54 38.4 54Z",
    fill: "#5B21FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2 41.88C65.04 42.96 65.04 44.52 64.32 45.6C62.76 48 59.52 48.6 57.12 47.04C56.52 46.68 56.04 46.2 55.68 45.6C54.96 44.4 55.08 42.96 55.8 41.88L60 36L64.2 41.88Z",
    fill: "#EEE8FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6 52.8H50.4V67.2H69.6V52.8Z",
    fill: "#EEE8FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4 62.4001C63.7255 62.4001 64.8 61.3256 64.8 60.0001C64.8 58.6746 63.7255 57.6001 62.4 57.6001C61.0745 57.6001 60 58.6746 60 60.0001C60 61.3256 61.0745 62.4001 62.4 62.4001Z",
    fill: "#5B21FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 62.4001C10.9255 62.4001 12 61.3256 12 60.0001C12 58.6746 10.9255 57.6001 9.6 57.6001C8.27451 57.6001 7.2 58.6746 7.2 60.0001C7.2 61.3256 8.27451 62.4001 9.6 62.4001Z",
    fill: "#5B21FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 54C15.7255 54 16.8 52.9254 16.8 51.6C16.8 50.2745 15.7255 49.2 14.4 49.2C13.0745 49.2 12 50.2745 12 51.6C12 52.9254 13.0745 54 14.4 54Z",
    fill: "#5B21FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 44.4C12.7882 44.4 14.4 42.7882 14.4 40.8C14.4 38.8117 12.7882 37.2 10.8 37.2C8.81177 37.2 7.2 38.8117 7.2 40.8C7.2 42.7882 8.81177 44.4 10.8 44.4Z",
    fill: "#5B21FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M72 14.4V9.6H69.24C69 8.76 68.76 8.04 68.28 7.2L70.68 4.8L67.08 1.2L64.68 3.6C63.96 3.24 63.12 2.88 62.28 2.64V0H57.48V2.76C56.64 3 55.92 3.24 55.08 3.72L52.68 1.32L49.08 4.92L51.48 7.32C51.12 8.04 50.76 8.88 50.52 9.72H48V14.52H50.76C51 15.36 51.24 16.08 51.72 16.92L49.32 19.32L52.92 22.92L55.32 20.52C56.04 20.88 56.88 21.24 57.72 21.48V24H62.52V21.24C63.36 21 64.08 20.76 64.92 20.28L67.32 22.68L70.92 19.08L68.52 16.68C68.88 15.96 69.24 15.12 69.48 14.28H72V14.4Z",
    fill: "#5B21FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60 16.8C62.651 16.8 64.8 14.6509 64.8 12C64.8 9.34898 62.651 7.19995 60 7.19995C57.349 7.19995 55.2 9.34898 55.2 12C55.2 14.6509 57.349 16.8 60 16.8Z",
    fill: "#EEE8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServe1);
export default __webpack_public_path__ + "static/media/serve1.ef3cdaab9ca9d35798b1b9d9baff81eb.svg";
export { ForwardRef as ReactComponent };